// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"0eb8fd42","977":"c3d99690"}[chunkId] + ".chunk.js";
};